import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { S as StyledP, a as StyledScreenReaderOnly, b as StyledSpan } from './Text.styles-B9-g8Nb7.js';
import { a as useHasTextAncestor, b as useTextAncestorColor, c as useTextAncestorWeight, H as HasTextAncestorContext } from '../HasTextAncestorContext/HasTextAncestorContext-DP5pzSWh.js';

const Text = ({
  color,
  elementRef,
  inline = false,
  renderAs = 'p',
  size = 'base',
  srOnly = false,
  weight,
  withMargin = false,
  ...rest
}) => {
  const {
    hasAncestor
  } = useHasTextAncestor();
  const derivedColor = useTextAncestorColor(color);
  const derivedWeight = useTextAncestorWeight(weight);
  let component = /*#__PURE__*/React__default.createElement(StyledP, _extends({}, rest, {
    $color: derivedColor,
    $weight: derivedWeight,
    $size: size,
    $inline: inline,
    $withMargin: withMargin,
    ref: elementRef
  }));
  if (srOnly) {
    component = /*#__PURE__*/React__default.createElement(StyledScreenReaderOnly, _extends({}, rest, {
      ref: elementRef
    }));
  }
  if (renderAs === 'span') {
    component = /*#__PURE__*/React__default.createElement(StyledSpan, _extends({}, rest, {
      $color: derivedColor,
      $weight: derivedWeight,
      $size: size,
      $inline: inline,
      $withMargin: withMargin,
      ref: elementRef
    }));
  }
  return hasAncestor ?
  // no need to re-apply context if the text is already wrapped
  component : /*#__PURE__*/React__default.createElement(HasTextAncestorContext.Provider, {
    value: {
      color,
      weight,
      size,
      hasAncestor: true
    }
  }, component);
};

export { Text as T };
//# sourceMappingURL=Text-D-u18aLP.js.map
